import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { useNavigate, useLocation } from 'react-router-dom';
import { isAxiosError } from 'axios';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Navbar from '../Navbar/Navbar';
import MessageBox from '../MessageBox/MessageBox';
import './SumPage.css';
import { useState, useEffect } from "react";
import useAuth from "../../hooks/useAuth";
import { ChangeEvent } from 'react';
import { Link } from '@mui/material';

import infoText from './infoText.json';

const PDF_URL = '/generatePDF/';
const SUBMISSION_SENT_URL = '/submissions/submit';

const PDF_DOWNLOAD_BUTTON_TITLE = 'POBIERZ PDF';
const SEND_SUBMISSION_BUTTON_TITLE = 'WYŚLIJ ZGŁOSZENIE';

const SEND_SUBMISSION_SUCCESS_MESSAGE = 'Sukces: udało się przesłać zgłoszenie!';
const SEND_SUBMISSION_ERROR_MESSAGE = 'Błąd: nie udało się przesłać zgłoszenia!';

const SumPage = () => {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();
  const bandName = sessionStorage.getItem('bandName');

  const [open, setOpen] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [isChecked, setIsChecked] = useState(false);

  const auth = useAuth();

  const isMember = sessionStorage.getItem('isMember');
  const hasPosition = sessionStorage.getItem('hasPosition');
  console.log("Position: ", hasPosition);

  const getPDF = async () => {
    const controller = new AbortController();

    try {
      const response = await axiosPrivate.get(PDF_URL, {
        signal: controller.signal,
        responseType: 'blob',
      });

      const url = URL.createObjectURL(response.data);
      const a = document.createElement('a');

      a.href = url;
      a.download = 'zgloszenie.pdf';

      a.click();
      URL.revokeObjectURL(url);
      a.remove();
    } catch (error) {
      if (isAxiosError(error)) {
        if (error.response && error.response.status === 403) {
          navigate('/', { state: { from: location }, replace: true });
        }
      }
    }

    controller.abort();
  };

  const sendSubmission = async () => {
    if (isMember !== '1') {
      setErrorMsg('Błąd: dodaj przynajmniej jednego członka zespołu przed wysłaniem zgłoszenia!');
      setOpen(true);
      return;
    }

    if (hasPosition !== '1') {
      setErrorMsg('Błąd: zdjęcie z pozycji na scenie jest wymagane!');
      setOpen(true);
      return;
    }

    if (!isChecked) {
      setErrorMsg('Błąd: musisz zaakceptować warunki, aby wysłać zgłoszenie!');
      setOpen(true);
      return;
    }

    const controller = new AbortController();

    try {
        const pdfResponse = await axiosPrivate.get(PDF_URL, {
            signal: controller.signal,
            responseType: 'blob',
        });

        const pdfBlob = pdfResponse.data;

        const data = new FormData();
        data.append('email', auth.auth.email);
        data.append('bandId', bandName || '');
        data.append('attachment', new File([pdfBlob], 'zgloszenie.pdf', { type: 'application/pdf' }));

        const config = {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        };

        const response = await axiosPrivate.post(SUBMISSION_SENT_URL, data, config);

        setErrorMsg(SEND_SUBMISSION_SUCCESS_MESSAGE);
        setOpen(true);
    } catch (error) {
        console.error("Error during submission:", error);
        setErrorMsg(SEND_SUBMISSION_ERROR_MESSAGE);
        setOpen(true);
    }

    controller.abort();
  };

  const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
    setIsChecked(event.target.checked);
  };

  return (
    <div className="band-container">
      <Navbar />
      <div className="band-content">

        <div className="info-text">
          <p>{infoText.pdfInfo}</p>
        </div>

        <Button variant="contained" type="submit" size="large" onClick={getPDF}>
          {PDF_DOWNLOAD_BUTTON_TITLE}
        </Button>

        <div className="info-text" style={{ marginTop: '20px' }}>
          <p>{infoText.submissionInfo}</p>
        </div>

        <FormControlLabel
          control={
            <Checkbox
              checked={isChecked}
              onChange={handleCheckboxChange}
              name="terms"
              color="primary"
              sx={{
                '& .MuiSvgIcon-root': {
                        border: '2px solid white',
                        borderRadius: '4px',
                    },
              }}
            />
          }
          label={
            <span>
              Akceptuję{' '}
              <Link
                href={infoText.link}
                target="_blank"
                rel="noopener noreferrer"
                color="primary"
              >
                warunki konkursu
              </Link>
            </span>
          }
        />

        <Button
          variant="contained"
          type="submit"
          size="large"
          onClick={sendSubmission}
          disabled={!isChecked}
        >
          {SEND_SUBMISSION_BUTTON_TITLE}
        </Button>
      </div>
      <MessageBox
        open={open}
        setOpen={setOpen}
        message={errorMsg}
        error={errorMsg !== SEND_SUBMISSION_SUCCESS_MESSAGE}
      />
    </div>
  );
};

export default SumPage;
